import { Description, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { READ_ONLY_NOTICE } from 'api/readOnlyAccess';
import Button from 'atoms/Button/Button';
import CheckSvg from 'images/v5/icons/check.svg';
import UserPlusSvg from 'images/v5/icons/user-plus-01.svg';
import CloseSvg from 'images/v5/icons/x-close.svg';
import { removeModal, selectModalByName } from 'store/layoutSlice';
import { getLayerZIndex } from 'utils/zIndexLayers';
import styles from './ReadOnlyNotice.module.scss';
const SIGNUP_URL = 'https://dashboard.stripe.com/register';
/** Shared signup prompt for every blocked write, regardless of the API transport. */
function ReadOnlyNotice() {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const modal = useSelector(selectModalByName(READ_ONLY_NOTICE));
    const close = () => dispatch(removeModal({ name: READ_ONLY_NOTICE }));
    return (React.createElement(Dialog, { open: Boolean(modal === null || modal === void 0 ? void 0 : modal.opened), onClose: close, className: styles.dialog, style: { zIndex: getLayerZIndex(modal === null || modal === void 0 ? void 0 : modal.layer) }, onKeyDownCapture: (event) => {
            // Close on keyup so Escape cannot also dismiss a form underneath this dialog.
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
            }
        }, onKeyUp: (event) => {
            event.stopPropagation();
            if (event.key === 'Escape')
                close();
        }, "data-read-only-notice": true },
        React.createElement("div", { className: styles.backdrop, "aria-hidden": "true" }),
        React.createElement("div", { className: styles.viewport },
            React.createElement(DialogPanel, { className: styles.panel },
                React.createElement("div", { className: styles.topbar },
                    React.createElement("span", { className: styles.badge }, t('read_only.badge')),
                    React.createElement(Button, { theme: "ghost", shape: "rounded", leftIcon: React.createElement(CloseSvg, null), title: t('close'), onClick: close })),
                React.createElement("div", { className: styles.content },
                    React.createElement("div", { className: styles.icon, "aria-hidden": "true" },
                        React.createElement(UserPlusSvg, null)),
                    React.createElement(DialogTitle, { className: styles.title }, t('read_only.title')),
                    React.createElement(Description, { className: styles.description }, t('read_only.description')),
                    React.createElement("p", { className: styles.invitation }, t('read_only.invitation')),
                    React.createElement("ul", { className: styles.benefits }, ['organize', 'collaborate', 'manage'].map((benefit) => (React.createElement("li", { key: benefit },
                        React.createElement(CheckSvg, { "aria-hidden": "true" }),
                        t(`read_only.benefits.${benefit}`))))),
                    React.createElement("div", { className: styles.actions },
                        React.createElement(Button, { color: "primary", size: "l", display: "block", href: SIGNUP_URL, leftIcon: React.createElement(UserPlusSvg, null), testId: "read-only-register" }, t('read_only.register')),
                        React.createElement(Button, { theme: "ghost", size: "m", display: "block", onClick: close }, t('read_only.continue'))))))));
}
export default ReadOnlyNotice;
